import {
  ChatThreadModel,
  ChatThreadModelPagedList,
  DeleteThreadByIdRequest,
  GetAllUserThreadsRequest,
  GetThreadByIdRequest,
  InitOverrideFunction,
  ThreadApi,
} from "../../../@api";

export class ThreadApiService implements Omit<
  ThreadApi,
  `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware"
> {
  constructor(private readonly api: ThreadApi) {}

  public async deleteThreadById(requestParameters: DeleteThreadByIdRequest): Promise<void> {
    return this.api.deleteThreadById(requestParameters);
  }
  public async getAllUserThreads(
    requestParameters: GetAllUserThreadsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ChatThreadModelPagedList> {
    return this.api.getAllUserThreads(requestParameters, initOverrides);
  }

  public async getThreadById(requestParameters: GetThreadByIdRequest): Promise<ChatThreadModel> {
    return this.api.getThreadById(requestParameters);
  }
}
